import React, { useRef } from "react";
import { Popper } from "@mui/material";

const ExamplePopper = ({ open, anchorEl, children }) => {
  const arrowRef = useRef(null);

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      disablePortal={false}
      modifiers={[
        {
          name: "flip",
          enabled: true,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: true,
            tether: true,
            rootBoundary: "viewport",
            padding: 8,
          },
        },
        {
          name: "arrow",
          enabled: false,
          options: {
            element: arrowRef.current,
          },
        },
      ]}
      sx={{ pt: 1 }}
    >
      {children}
    </Popper>
  );
};

export default ExamplePopper;
